import React, { Component } from "react";

export default class DashboardItem extends Component {
  render() {
    return (
      <div
        className={!this.props.disable ? "menuItem" : "menuItem-disable"}
        disabled={this.props.disable}
        onClick={this.props.onClick}
      >
        <div className="menuItemImageContainer">
          <img src={this.props.img} alt="" className="menuItemImage" />
        </div>
        <div className="menuItemTitle">{this.props.title}</div>
        {/* <div className="menuItemTextContainer">
          <div className="menuItemTitle">{this.props.title}</div>
          <div className="menuItemDes">{this.props.description}</div>
        </div> */}
      </div>
    );
  }
}
